import * as React       from "react";
import ReactTooltip     from 'react-tooltip';
import {cx}             from 'emotion';
import "./subscriptions-details.scss";


import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";
import {Responsive}     from "@Common/ui-components/responsive";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {SubscriptionsDetailsDesktop}  from "./desktop/subscriptions-details-desktop";
import {SubscriptionsDetailsDesktop2} from "./desktop/subscriptions-details-desktop-2";
import {ManageSubscriptionsCard}      from "./manage-subscriptions-card/manage-subscriptions-card";
import {SubscriptionsDetailsMobile}   from "./mobile/subscriptions-details-mobile";
import {SubscriptionsDetailsMobile2}  from "./mobile/subscriptions-details-mobile-2";
import {ChangeSubscriptionCard}       from "./subscription-card/change-subscription-card";
import {ChangeSubscriptionCardMobile} from "./subscription-card/change-subscription-card-mobile";
import {SubscriptionModal}            from "./subscription-modal/subscription-modal";
import {SubscribeButton}              from "./subscribe-button/subscribe-button";
import {SyncSubscriptions}            from "./sync-subscriptions/sync-subscriptions";
import {TermsModal}                   from "./terms-modal/terms-modal";
import {EmulationModal}               from "../common/emulation-modal/emulation-modal";
import {COMPANY_LEVEL, USER_LEVEL}    from "../common/logic/user-level";

export const SubscriptionsDetails = ({referenceUrl}) => cs(
    consumeContext("apis"),
    consumeContext("userLevels"),
    consumeContext("session"),
    consumeContext("themeScheme"),
    consumeContext("routerHistory"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["emulationModal", (_, next) => EmulationModal({next})],
    ["termsModal", (_, next) => TermsModal({next})],
    ["refresh", ({session},next) => next(
        async () => await session.reload()
    )],
    ["subscriptionModal", ({refresh}, next) => SubscriptionModal({
        urlParam: "createSubscription",
        refresh,
        referenceUrl,
        next
    })],
    ["agent", ({session}, next) => next(session?.data?.agent)],
    ["hasPlans", ({agent}, next) => next(
        agent?.subscriptions
    )],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            sm: 860,
            md: 1280,
        },
        next,
    }}/>],
    ["subscriptions", ({apis, themeScheme, subscriptionModal, agent}, next) => (
        themeScheme?.type === "loggedIn" ?
        Load2({
           _key: agent?.idAgent,
           fetch: () =>  apis.next.subscription.getDetails({idAgent: agent?.idAgent}),
           next,
       }) : SubscribeButton({subscriptionModal, planId: null}))
    ],
    ({subscriptions}, next) => (
        subscriptions?.value?.statusCode === "Subscriptions-GA04" ? (
            <div className="subscriptions-details-x9o">
                <div className="message" xd-qa-type="label" xd-qa-name="error">
                    {subscriptions.value.message}
                </div>
                {subscriptions.value?.internalMessage && <div className="message" xd-qa-type="label" xd-qa-name="internal">
                    Internal: <pre>{JSON.stringify(JSON.parse(subscriptions.value.internalMessage), null, 2)}</pre>
                </div>}
            </div>
        ) : (
            next()
        )
    ),
    ["activeSubscription", ({subscriptions}, next) => next(
        subscriptions?.value?.data?.find(subscription => subscription.status === "active") ??
        subscriptions?.value?.data?.find(subscription => subscription.status === "non_renewing") ??
        subscriptions?.value?.data?.[0]
    )],
    ["subscriptionPlans", ({apis}, next) => Load2({
        fetch: async () => {
            const plans = await apis.next.subscription.getSubscriptionPlans()
            return plans.data[0]
        },
        next,
    })],
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ({}, next) => (
        <div className="subscriptions-details-x9o">
            {next()}
        </div>
    ),
    ({apis, agent, userLevels, emulationModal, query, session, routerHistory}, next) => (
        query && query['state'] === "succeeded" ? (
            <>
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Your Profile is being updated. Do not hit back or refresh the page.
                </div>
                {Invoke({
                    action: async () => {
                        await apis.next.subscription.sync();
                        routerHistory.replace('/manage-subscriptions');
                        await session.reload();
                    },
                })}
            </>
        ) : !agent ? (
            <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                Loading...
            </div>
        ) : agent?.idAgent && agent?.idAgent != "Branch Order" ? (
            next()
        ) : (
            <div className="center">
                {userLevels.userLevel !== USER_LEVEL ? (
                    <>
                        {"In order to manage subscriptions, you must "}
                        <a
                            className="emulation"
                            xd-qa-type="button"
                            xd-qa-name="Emulation"
                            onClick={() => emulationModal.show()}
                        >
                            {userLevels.userLevel === COMPANY_LEVEL ? (
                                "Select Office & User"
                            ) : (
                                "Select User"
                            )}
                        </a>
                    </>
                ) : (
                    "Something went wrong"
                )}
            </div>
        )
    ),
    ({hasPlans, activeSubscription, subscriptionPlans, termsModal, subscriptionModal, agent, responsive}) => (
        !hasPlans ? (
            <div className="loading" xd-qa-type="label" xd-qa-name="No Subscriptions">
                Subscriptions are disabled for your company. Please contact your company admin for more information.
            </div>
        ) : hasPlans?.length === 0 ? cs(
            ["selectedPlanId", (_, next) => subscriptionPlans.value && UseState({
                initValue: subscriptionPlans.value?.pricePoints?.[1]?.idChargebeePricePoint ?? subscriptionPlans.value?.pricePoints[0].idChargebeePricePoint,
                next,
            })],
            ({selectedPlanId}) => <>
                {responsive.lt("sm") ? (
                    SubscriptionsDetailsMobile({selectedPlanId, perks, subscriptionPlans, subscriptionModal})
                ) : (
                    SubscriptionsDetailsDesktop({selectedPlanId, subscriptionPlans, subscriptionModal})
                )}
                <div className="section">
                    {TermsAndConditions({termsModal})}
                    {SyncSubscriptions({})}
                </div>
            </>
        ) : (<>
                {responsive.lt("sm") ? (
                    <div className="mobile-subscriptions-container">
                        {ManageSubscriptionsCard({agent, subscriptionPlans: subscriptionPlans.value, activeSubscription, subscriptionModal})}
                        <div className="cards-container">
                            {activeSubscription?.idPlanType === PLAN_TYPE.MONTH ? (
                                SubDescriptionsReady({activeSubscription, subscriptionPlans}) && HandleMonthlySubscriptionFirst({activeSubscription, subscriptionModal, subscriptionPlans: subscriptionPlans.value, responsive})
                            ) : activeSubscription?.idPlanType === PLAN_TYPE.YEAR ? (
                                SubDescriptionsReady({activeSubscription, subscriptionPlans}) && HandleYearlySubscriptionFirst({activeSubscription, subscriptionModal, subscriptionPlans: subscriptionPlans.value, responsive})
                            ) : (
                                SubDescriptionsReady({activeSubscription, subscriptionPlans}) && HandleCancelledSubscription({activeSubscription, subscriptionModal, subscriptionPlans: subscriptionPlans.value, responsive})
                            )}
                        </div>
                    </div>
                ) : (
                    <div className={cx("subscriptions-container", {tablet: responsive.lt("md") && responsive.ge("sm")})}>
                        <div className="left">
                            <div className={cx("header", {tablet: responsive.lt("md") && responsive.ge("sm")})}>
                                <div className="title" xd-qa-type="label" xd-qa-name="Subscription Details">
                                    Subscription Details
                                </div>
                            </div>
                            {ManageSubscriptionsCard({agent, subscriptionPlans: subscriptionPlans.value, activeSubscription, subscriptionModal})}
                        </div>
                        <div className="right">
                            <div className="header" xd-qa-type="label" xd-qa-name="XD+ Subscription Plans">XD+ Subscription Plans</div>
                            <div className="cards-container">
                                {activeSubscription?.idPlanType === PLAN_TYPE.MONTH ? (
                                    SubDescriptionsReady({activeSubscription, subscriptionPlans}) && HandleMonthlySubscriptionFirst({activeSubscription, subscriptionModal, subscriptionPlans: subscriptionPlans.value, responsive})
                                ) : activeSubscription?.idPlanType === PLAN_TYPE.YEAR ? (
                                    SubDescriptionsReady({activeSubscription, subscriptionPlans}) && HandleYearlySubscriptionFirst({activeSubscription, subscriptionModal, subscriptionPlans: subscriptionPlans.value, responsive})
                                ) : (
                                    SubDescriptionsReady({activeSubscription, subscriptionPlans}) && HandleCancelledSubscription({activeSubscription, subscriptionModal, subscriptionPlans: subscriptionPlans.value, responsive})
                                )}
                            </div>
                        </div>
                    </div>
                )}
            <div className="section">
                {TermsAndConditions({termsModal})}
                {SyncSubscriptions({})}
            </div>
        </>)
    )
);


const HandleMonthlySubscriptionFirst = ({activeSubscription, subscriptionModal, subscriptionPlans, responsive}) => (<>
    {responsive.lt("sm") ? (<>
        {ChangeSubscriptionCardMobile({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Monthly", action: Actions.SCHEDULED})}
        {ChangeSubscriptionCardMobile({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Yearly", action: Actions.INSTANT})}
    </>) : (<>
        {ChangeSubscriptionCard({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Monthly", action: Actions.SCHEDULED})}
        {ChangeSubscriptionCard({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Yearly", action: Actions.INSTANT})}
    </>)}
</>)

const HandleYearlySubscriptionFirst = ({activeSubscription, subscriptionModal, subscriptionPlans, responsive}) => (<>
    {responsive.lt("sm") ? (<>
        {ChangeSubscriptionCardMobile({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Yearly", action: Actions.SCHEDULED})}
        {ChangeSubscriptionCardMobile({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Monthly", action: Actions.SCHEDULED})}
    </>) : (<>
        {ChangeSubscriptionCard({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Yearly", action: Actions.SCHEDULED})}
        {ChangeSubscriptionCard({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Monthly", action: Actions.SCHEDULED})}
    </>)}
</>)

const HandleCancelledSubscription = ({activeSubscription, subscriptionModal, subscriptionPlans, responsive}) => (<>
    {responsive.lt("sm") ? (<>
        {ChangeSubscriptionCardMobile({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Monthly", action: Actions.INSTANT})}
        {ChangeSubscriptionCardMobile({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Yearly", action: Actions.INSTANT})}
    </>) : (<>
        {ChangeSubscriptionCard({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Monthly", action: Actions.INSTANT})}
        {ChangeSubscriptionCard({activeSubscription, subscriptionModal, subscriptionPlans, advertisedPlan: "Yearly", action: Actions.INSTANT})}
    </>)}
</>)

const SubDescriptionsReady = ({activeSubscription, subscriptionPlans}) => {return activeSubscription && subscriptionPlans.value}

const perks = [
    {
        icon: require('./images/shipping-truck.svg'),
        line1: "FREE",
        line2: "Ground Shipping",
        asterisk: true
    },
    {
        icon: require('./images/mail-envelope.svg'),
        line1: "FREE",
        line2: "Targeted Mailing Lists",
        asterisk: true
    },
    {
        icon: require('./images/lightning-bolt.svg'),
        line1: "Exclusive",
        line2: "Sales Events",
        asterisk: false
    },
    {
        icon: require('./images/gift-box.svg'),
        line1: "FREE",
        line2: "Business Cards",
        asterisk: true
    },
];

const subscriptionPlans_constant = [
    {
        id: "Basic-Subscription-USD-Monthly",
        name: "Monthly Subscription",
        description: "Pay as you go, cancel anytime",
        bestChoice: false,
        cost: 9.99
    },
    {
        id: "Basic-Subscription-USD-Yearly",
        name: "Annual Subscription",
        description: "Pay up front and save 17% vs. the monthly plan, plus receive 15% off your next order",
        bestChoice: true,
        cost: 99.99
    },
];

const TermsAndConditions = ({termsModal}) => (
    <div
        className="terms"
        xd-qa-type="link"
        xd-qa-name="Terms"
        onClick={() => termsModal.show()}
    >
        {"See Terms & Conditions "}<span className="asterisk">*</span>
    </div>
)

const Actions = {
    INSTANT: 'instant',
    SCHEDULED: 'scheduled',
    REVIEW: 'review'
};

export const PLAN_TYPE = {
    MONTH: 1,
    YEAR:  2,
}